import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { OPTION_VALUES, PaymentOptionName } from "@ipru-common/constants/InputValues";
import GlobalStore from "@ipru-common/store/GlobalStore";
import CommonKeys from "./CommonUserInput";
import { mapDataToSuitabilityData } from "@ipru-common/components/CommonComponents/SuitabilityCalModal/SuitabilityMapper";
import { convertToWords, readQueryParams } from "@ipru-common/utils/CommonFunctions";
import { getCurrentTimeStamp, getWOPOption, trueFalse } from "../SavingsAppForm/SavingAppFormsUtils";
import { getAge } from "@ipru-common/libs/ValidationSchemas/CustomRules";

const getSaralPensionUserInput = () => {
  const { appFormData, quoteFormData, calculatorFormData, existingCustomer, currentPageStep } =
    GlobalStore.getSnapshot();

  const suitabilityData = mapDataToSuitabilityData(calculatorFormData, quoteFormData);
  const queryParams = readQueryParams();

  const UID = queryParams.get("UID") || "480";
  const { wopOption } = getWOPOption(quoteFormData?.selectedRiders);
  const annuityAmount = quoteFormData?.calculatedData?.saralQuoteResponse?.AnnuityAmount;
  const annuityOption = quoteFormData?.calculatedData?.saralQuoteResponse?.AnnuityOption;

  let saralPensionInput = {
    premiumpaymentoption: PaymentOptionName[quoteFormData?.paymentOption],
    sumassured: quoteFormData?.SA,
    accidental_death_benefit: quoteFormData?.ADB_SA,
    critical_illness_benefit: quoteFormData?.CI_SA,
    payoutoptions: LMS_CONSTANTS[quoteFormData?.payoutType],
    paymentfrequency: quoteFormData?.paymentFrequency,
    nominee: appFormData?.formWizard?.nomineeDetails,
    paymentoption: LMS_CONSTANTS[quoteFormData?.paymentOption],
    mode: suitabilityData?.mode,
    ppt: quoteFormData?.ppt,
    adbr: suitabilityData?.adbr,
    funds: suitabilityData?.funds,
    ats: suitabilityData?.ats,
    pan: appFormData?.panNumber,
    address: appFormData?.personalDetails?.full_address,
    uid: UID,
    AppNo: appFormData?.appNO,
    lifecover2: convertToWords(quoteFormData?.lifeCover), //check
    sumassured2: convertToWords(quoteFormData?.SA),
    pagename: appFormData?.ProductName, //check
    investvalue: quoteFormData?.investvalue,
    paymentOption: LMS_CONSTANTS[quoteFormData?.paymentOption],

    lifeCover: quoteFormData?.lifeCover,
    SavingsPercentage: suitabilityData?.pastPerformancePercent,
    // Pincode: calculatorFormData?.pincode,
    // LDUID: UID,
    timestamp: getCurrentTimeStamp(),
    PageName: appFormData?.ProductName,
    p_gender: calculatorFormData?.propGender,
    p_dob: calculatorFormData?.propAge,
    suitCheckbox: suitabilityData?.skip_suitability_check || false,

    isNRI: trueFalse(calculatorFormData.nri) ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING,
    lms_nri: calculatorFormData?.nri,
    productId: calculatorFormData?.productCode,
    WOP_SelctedOption: wopOption,
    rider1: quoteFormData?.selectedRiders?.[0],
    rider2: quoteFormData?.selectedRiders?.[1],
    rider3: quoteFormData?.selectedRiders?.[2],
    brochure_selected: "",
    Tollfree_selected: "",
    qdata: queryParams?.get("qdata") ?? "",
    UID: UID,
    p_age: calculatorFormData?.propAge ? getAge(calculatorFormData?.propAge) : "",
    TRAI_FLAG: calculatorFormData?.trai_flag ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    AnnuityAmount: annuityAmount,
    annuityOption: annuityOption,
    channel: "BOL",
    gauranteedBenefit: "false",
    IncomeBenefit: "",
    investment_frequency: quoteFormData?.incomeForFrequency,
    keyword: "",
    Lead_type: "Lead",
    Maritalstatus: appFormData?.marital_status,
    matchtype: "",
    Next_Year_Premium: "", // TODO
    NPS_Flag: "No",

    PaymentFrequency: quoteFormData?.paymentFrequency,
    PayoutOptions: quoteFormData?.selectedAnnuityOption?.annuityOption,
    PensionFor: quoteFormData?.annuityOption,
    Plan: "",
    planType: "GA II",
    PolicyTerm: quoteFormData?.term,
    PPT: quoteFormData?.ppt,
    Premium: quoteFormData?.invest,
    premiumPaymentOption: "",
    reverse: "false",
    selectedPlan: "0",
    session_UID: "",
    SpecialDate: quoteFormData?.specialDate,
    Spouse_DOB: quoteFormData?.joint_life_dob,
    Spouse_Gender: quoteFormData?.gender,
    Spouse_name: quoteFormData?.joint_life_name,
    Spouse_Relation: quoteFormData?.joint_life_relation,
    sumAssured: "",
    term: quoteFormData?.term,
    PurchaseFor: calculatorFormData?.relaiton_appForm,
    // NOT IN GPP-FLEXI, BUT NEEDED BEC OF COMMON IMPLEMENTATION
    trai_flag: calculatorFormData?.trai_flag ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    isEnglish: "TRUE",
    currentPageStep: currentPageStep,
  };

  return { ...CommonKeys(calculatorFormData, existingCustomer, quoteFormData), ...saralPensionInput };
};

export default getSaralPensionUserInput;
